<template>
  <div class="free-night">
    <!-- TITULO -->
    <div class="form--title">
      <PmwHeading size="paragraph-80" weight="weight-light">
        Noite grátis
      </PmwHeading>
    </div>

    <!-- BOTÃO DE MOSTRAS INPUTS -->
    <div v-if="!fluctuationData.utilizaNoitesGratis" class="form--row">
      <PmwButton
        :hasIcon="true"
        layout="outline"
        variation="blue-100"
        class="form--button"
        @click="fluctuationData.utilizaNoitesGratis = true"
      >
        Adicionar regra de noite grátis
      </PmwButton>
    </div>

    <!-- INPUTS DOS CAMPOS DE NOITE GRATIS -->
    <div v-if="fluctuationData.utilizaNoitesGratis" class="form--row">
      <FreenNightsInputs
        :fluctuationData="fluctuationData"
        @closeInputs="removeFreeNightHandler"
      />
    </div>
  </div>
</template>

<script>
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton'
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'
import FreenNightsInputs from './FreenNightsInputs'

export default {
  name: 'FreeNight',
  components: {
    PmwHeading,
    PmwButton,
    FreenNightsInputs
  },

  props: {
    fluctuationData: {
      type: Object,
      default: () => ({})
    },

    /** Erros (array de erros que foram identificados pelo back-end) */
    errors: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {}
  },

  methods: {
    removeFreeNightHandler() {
      this.fluctuationData.utilizaNoitesGratis = false
      this.fluctuationData.diariasNoitesGratis = null
      this.fluctuationData.quantidadeNoitesGratis = null
      this.fluctuationData.tipoNoitesGratis = null
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  &--button {
    max-width: 240px;
    width: 240px;
  }

  &--row {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 24px;
    margin-bottom: 32px;
  }

  &--title {
    margin-bottom: 24px;
    position: relative;
  }
}
</style>
